import { AxiosResponse } from 'axios'

// eslint-disable-next-line import/prefer-default-export
export function extractFileNameFromContentPositionHeader(response: AxiosResponse, defaultFileName = 'download'): string {
  const contentDispositionHeader = response?.headers['content-disposition'] ?? ''
  const [, fileName] = contentDispositionHeader.split('filename=')
  return fileName ?? defaultFileName
}
